'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('@/config');

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue = require('raven-js/plugins/vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    //初始化sentry
    _ravenJs2.default.config(_config.sentry).addPlugin(_vue2.default, Vue).install();
    Vue.config.errorHandler = function (err, vm) {
      err && console.error(err);
      _ravenJs2.default.captureMessage(err, {
        level: 'error'
      });
    };
    Object.defineProperty(Vue.prototype, '$log', {
      value: {
        write: function write() {
          var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
          var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

          _ravenJs2.default.captureMessage(title, { level: level, context: context, tags: tags });
        },
        writeExLog: function writeExLog(ex) {
          var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
          var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

          _ravenJs2.default.captureException(ex, { level: level, tags: tags, extra: { context: context } });
        }
      },
      writable: false
    });
  }
};